export enum AffiliateActions {
  UPDATE_REF_AFFILIATED_STATUS_REQUEST = "UPDATE_REF_AFFILIATED_STATUS_REQUEST",
  UPDATE_REF_AFFILIATED_STATUS_SUCCESS = "UPDATE_REF_AFFILIATED_STATUS_SUCCESS",
  UPDATE_REF_AFFILIATED_STATUS_FAILURE = "UPDATE_REF_AFFILIATED_STATUS_FAILURE",
}
